import { render, staticRenderFns } from "./ForceResetPasswd.vue?vue&type=template&id=95bb79e0"
import script from "./ForceResetPasswd.vue?vue&type=script&lang=js"
export * from "./ForceResetPasswd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports